import { createAction, props } from '@ngrx/store';
import { CommonQuestionModel } from 'src/app/model/common/question';
import { CommonQuestionViewModel } from 'src/app/model/common/question.view';

enum CommonQuestionActionLabels {
  SET_ADMIN_RESULT = 'COMMON_QUESTION_SET_ADMIN_RESULT',
  SET_CONSULT_TOP_QUESTIONS = 'COMMON_QUESTION_SET_CONSULT_TOP_QUESTIONS',
  SET_CONSULT_BOTTOM_QUESTIONS = 'COMMON_QUESTION_SET_CONSULT_BOTTOM_QUESTIONS',
  SET_ALL_DEFAULT = 'COMMON_QUESTION_SET_ALL_DEFAULT',
}

export const commonQuestionActions = {
  setAdminResultAction: createAction(
    CommonQuestionActionLabels.SET_ADMIN_RESULT,
    props<{ result: CommonQuestionModel[] }>()
  ),
  setConsultTopQuestionsAction: createAction(
    CommonQuestionActionLabels.SET_CONSULT_TOP_QUESTIONS,
    props<{ topQuestions: CommonQuestionViewModel[] }>()
  ),
  setConsultBottomQuestionsAction: createAction(
    CommonQuestionActionLabels.SET_CONSULT_BOTTOM_QUESTIONS,
    props<{ bottomQuestions: CommonQuestionViewModel[] }>()
  ),
  setAllDefaultAction: createAction(
    CommonQuestionActionLabels.SET_ALL_DEFAULT,
    props<any>()
  ),
};
